import { render, staticRenderFns } from "./MedicalSchool.vue?vue&type=template&id=414302d9&scoped=true"
import script from "./MedicalSchool.vue?vue&type=script&lang=js"
export * from "./MedicalSchool.vue?vue&type=script&lang=js"
import style0 from "./MedicalSchool.vue?vue&type=style&index=0&id=414302d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414302d9",
  null
  
)

export default component.exports